import { lazy, Suspense } from 'react';
import {
    BrowserRouter, Route, Routes
} from "react-router-dom";
import 'swiper/css';
import 'swiper/css/bundle';
import './App.scss';
import Modal from "./components/Modal/Modal";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from 'react-redux';
import { useGetUserQuery } from './store/services/userServices';

// import MainLayout from './layouts/MainLayout';
// import Home from './pages/Home/Home';
// import AboutPage from "./pages/AboutPage/AboutPage";
// import BecomeTutor from "./pages/BecomeTutor/BecomeTutor";
// import Blog from "./pages/Blog/Blog";
// import BlogDetail from "./pages/BlogDetail/BlogDetail";
// import CourseCreated from "./pages/CourseCreated/CourseCreated";
// import CourseDetail from "./pages/CourseDetail/CourseDetail";
// import CourseList from "./pages/CourseList/CourseList";
// import EditInfo from "./pages/EditInfo/EditInfo";
// import Login from "./pages/Login/Login";
// import ManagePost from "./pages/ManagePost/ManagePost";
// import NotFound from "./pages/NotFound/NotFound";
// import TutorBooking from "./pages/TutorBooking/TutorBooking";
// import TutorDetail from "./pages/TutorDetail/TutorDetail";
// import TutorList from "./pages/TutorList/TutorList";
// import WriteBlog from "./pages/WriteBlog/WriteBlog";
// import ScrollTop from "./utils/ScrollTop";
// import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
// import ResetPassword from "./pages/ResetPassword/ResetPassword";
// import ChangePassword from "./pages/ChangePassword/ChangePassword";

const MainLayout = lazy(() => import('./layouts/MainLayout'));
const Home = lazy(() => import('./pages/Home/Home'));
const AboutPage = lazy(() => import("./pages/AboutPage/AboutPage"));
const BecomeTutor = lazy(() => import("./pages/BecomeTutor/BecomeTutor"));
const Blog = lazy(() => import("./pages/Blog/Blog"));
const BlogDetail = lazy(() => import("./pages/BlogDetail/BlogDetail"));
const CourseCreated = lazy(() => import("./pages/CourseCreated/CourseCreated"));
const CourseDetail = lazy(() => import("./pages/CourseDetail/CourseDetail"));
const CourseList = lazy(() => import("./pages/CourseList/CourseList"));
const EditInfo = lazy(() => import("./pages/EditInfo/EditInfo"));
const Login = lazy(() => import("./pages/Login/Login"));
const ManagePost = lazy(() => import("./pages/ManagePost/ManagePost"));
const NotFound = lazy(() => import("./pages/NotFound/NotFound"));
const TutorBooking = lazy(() => import("./pages/TutorBooking/TutorBooking"));
const TutorDetail = lazy(() => import("./pages/TutorDetail/TutorDetail"));
const TutorList = lazy(() => import("./pages/TutorList/TutorList"));
const WriteBlog = lazy(() => import("./pages/WriteBlog/WriteBlog"));
const ScrollTop = lazy(() => import("./utils/ScrollTop"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword/ResetPassword"));
const ChangePassword = lazy(() => import("./pages/ChangePassword/ChangePassword"));

function App() {
    const { accessToken } = useSelector(store => store.auth);
    const { data: user } = useGetUserQuery('', { skip: !accessToken, refetchOnMountOrArgChange: true, });
    return (
        <Suspense fallback={<Modal />}>
            <BrowserRouter>
                <ScrollTop />
                <Routes>
                    <Route path="/" element={<MainLayout />}>
                        <Route index element={<Home />} />
                        <Route path='*' element={<NotFound />} />
                        <Route path="login" element={<Login />} />
                        <Route path="forgot-password" element={<ForgotPassword />} />
                        <Route path="reset-password/:id/:token" element={<ResetPassword />} />
                        <Route path="change-password" element={<ChangePassword />} />
                        <Route path="about" element={<AboutPage />} />
                        <Route path="tutor-list" element={<TutorList />} />
                        {user?.avatar && <Route path="tutor-list/become-tutor" element={<BecomeTutor />} />}
                        <Route path="tutor-list/tutor-detail/:id" element={<TutorDetail />} />
                        {user?.avatar && <Route path="tutor-list/tutor-detail/tutor-booking/:id" element={<TutorBooking />} />
                        }
                        <Route path="course-list" element={<CourseList />} />
                        <Route path="course-list/course-detail/:id" element={<CourseDetail />} />
                        {user?.tutor && <Route path="course-list/course-created" element={<CourseCreated />} />}
                        <Route path="blog" element={<Blog />} />
                        <Route path="blog/blog-detail/:id" element={<BlogDetail />} />
                        {user?.avatar && <Route path="blog/write-blog" element={<WriteBlog />} />}
                        <Route path="manage-post" element={<ManagePost />} />
                        <Route path="edit-info" element={<EditInfo />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </Suspense>

    );
}

export default App;
